import React from 'react';
import 'suneditor/dist/css/suneditor.min.css'; 
import SunEditor from 'suneditor-react';

const RichTextEditor = ({ value, onChange, height = '300px' }) => {
  return (
    <SunEditor
      setContents={value}
      onChange={onChange}
      height={height}
      setOptions={{
        buttonList: [
          ['undo', 'redo'],
          ['bold', 'italic', 'underline', 'strike'],
          ['font', 'fontSize','formatBlock'],
          ['align', 'list', 'lineHeight'],
          ['table', 'link', 'image', 'video'],
          ['fullScreen', 'showBlocks', 'codeView', 'preview'],
        ],
      }}
    />
  );
};

export default RichTextEditor;
